import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import OurValues from '../Components/who/OurValues'
import WhatSetsUsApart from '../Components/who/WhatSetsUsApart'
import FounderMessage from '../Components/leadership/FounderMessage'
import { ArrowRight, Quote } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';

function WhoWeAre() {
    return (
        <div>
            <Helmet>
    <title>
        Who We Are | Enterprise AI & ServiceNow Consulting & Technology Partner | Mobikode
    </title>

    <meta
        name="description"
        content="Learn about Mobikode, a technology partner helping businesses grow with practical digital solutions, modern technology, cloud platforms, web applications, and scalable systems built around real business needs."
    />

    <meta
        name="keywords"
        content="Mobikode, About Mobikode, Who We Are Mobikode, Technology Partner, Enterprise AI & ServiceNow Consulting Company, IT Solutions Company, Digital Technology Services, Business Technology Solutions, Enterprise AI & ServiceNow Consulting Services, IT Consulting Company, Software Development Company, Cloud Solutions Company, Technology Consulting Services, Enterprise Technology Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/who-we-are"
    />

    <meta
        property="og:title"
        content="Who We Are | Enterprise AI & ServiceNow Consulting & Technology Partner | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's approach to technology, Enterprise AI & ServiceNow Consulting, and business growth. We create practical, future-ready solutions that help organizations solve challenges and move forward with confidence."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/who-we-are"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/product/whoweare.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Who We Are | Enterprise AI & ServiceNow Consulting & Technology Partner | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Get to know Mobikode, a trusted technology partner focused on practical digital solutions, innovation, efficiency, and long-term business growth."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/product/whoweare.png"
    />
</Helmet>
            <WhoHero
                title="Who We Are"
                text="Technology. Transformation. Trust."
                imgData="/assets/product/whoweare.png"
            />
            <section className='overflow-hidden'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] lg:py-[88px] py-[40px] relative">
                    <div className="absolute right-0 top-[-450px] hidden lg:block">
                        <img src="/assets/about/wrap2.svg" alt="" />
                    </div>
                    <div className="flex flex-col lg:flex-row relative w-full items-center">
                        <div className="max-w-[671px] w-full z-0">
                            <img
                                src="/assets/v/item8.jpg"
                                alt="who-we-are"
                                className="w-full h-auto "
                            />
                        </div>
                        <div className="
                relative           
                lg:absolute        
                lg:right-[40px] 
                lg:top-[85px] 
                mt-[-40px] lg:mt-0 
                z-10 
                max-w-[789px] 
                w-[92%] lg:w-full 
                lg:p-[40px] p-[20px] sm:p-[30px] 
                bg-[#FFFFFF] 
                shadow-[0_10px_30px_rgba(0,0,0,0.1)] lg:shadow-none 
            ">
                            <p className="font-[500] font-graphik text-[14px] md:text-[16px] leading-[22px] md:leading-[28px] text-[#49577A]">
                                Mobikode is all about helping businesses grow through smart and practical technology. We work with companies across different industries, taking the time to understand their unique challenges and goals before building solutions that truly fit.

                                <br />
                                <br />
                                We know how important the right digital tools are for making work easier and more efficient. That’s why we focus on creating simple, future-ready solutions that support real growth. More than just a service provider, we work alongside our clients helping them improve processes, solve problems, and build systems that continue to deliver value over time.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <div className="bg-[#F1F1F1] relative overflow-hidden lg:p-[50px] p-[20px]">
                        <div className="absolute lg:block hidden right-0 top-0">
                            <img src="/assets/about/wrap1.png" alt="" />
                        </div>
                        <h6 className="font-[600] font-sora text-[32px] leading-[40px] text-[#01386A]">Our Vision</h6>
                        <p className="max-w-[571px] w-full pt-[30px] font-[500] font-graphik lg:text-[16px] text-[14px] leading-[24px] text-[#49577A]">
                            At Mobikode, we simply want to help businesses grow with the right technology. Our vision is to become a trusted IT partner by creating solutions that are not just innovative, but genuinely useful and easy to rely on. We believe great results come from clear thinking and strong strategy whether it’s building web apps, products, or cloud solutions. When you work with us, you get more than just tech, you get a team that understands your goals and supports your journey. We focus on building long-term relationships and delivering solutions that help you move forward with confidence.
                        </p>
                    </div>
                </div>
            </section>
            {/* <FounderMessage/> */}
            {/* <section>
                <div className="flex flex-col md:flex-row w-full items-center max-w-[1440px] mx-auto lg:px-[80px] px-[20px] lg:pb-[80px] pb-[40px]">

                    <div className="w-full md:w-full max-w-[250px] h-[250px] md:h-[260px]">
                        <img
                            src="/assets/sales/ajit yadav.jpeg"
                            alt="Ajit Yadav"
                            className="w-full h-full object-cover rounded-lg shadow-sm"
                        />
                    </div>

                    <div className="w-full md:w-full px-0 py-6 md:px-10 md:py-8 flex flex-col justify-center">
                        <h3 className="font-[600] font-sora text-[32px] leading-[40px] text-[#01386A] mb-[10px]">
                            Ajit Yadav
                        </h3>

                        <p className="font-[500] font-graphik text-[18px] leading-[24px] text-[#49577A] mb-4">
                            Founder & CEO, Mobikode
                        </p>

                        <p className="font-[500] font-graphik text-[18px] leading-[24px] text-[#49577A] mb-4">
                            At Mobikode, our journey began with a simple yet powerful belief: technology should not just support businesses, it should accelerate them.
                        </p>

                        <p className="font-[500] font-graphik text-[18px] leading-[24px] text-[#49577A] mb-4">
                            When I founded Mobikode in 2017, the vision was clear: to build a technology partner that delivers not only solutions, but measurable impact.
                        </p>

                        <p className="font-[500] font-graphik text-[18px] leading-[24px] text-[#49577A] mb-4">
                            Today, as Enterprise AI & ServiceNow Consulting continues to redefine industries, our focus remains stronger than ever.
                        </p>

                        <h3 className="text-[#01386A] text-[20px] md:text-[20px] font-[600] font-sora mt-6">
                            Let's build the future together.
                        </h3>

                        <p className="font-[500] font-graphik text-[18px] leading-[24px] text-[#49577A] mt-2 mb-6">
                            Warm regards, <br /> Ajit Yadav
                        </p>

                        <Link
                            to="/founders-message"
                            className="group flex items-center gap-3 text-[#01386A] font-sora font-[600] text-[16px] md:text-[18px] hover:text-[#49577A] transition-colors w-fit"
                        >
                            <div className="bg-[#01386A] p-2.5 rounded-full group-hover:translate-x-2 group-hover:bg-[#49577A] transition-all duration-300 shadow-md">
                                <ArrowRight size={20} className="text-white" />
                            </div>
                        </Link>

                    </div>
                </div>
            </section> */}
            <section className="w-full bg-white py-12 md:py-20">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                    <div className="flex flex-col md:flex-row items-stretch border border-gray-200 shadow-sm rounded-sm overflow-hidden bg-white">

                        {/* Left Side - Image with Floating Box */}
                        <div className="w-full md:w-full max-w-[417px] relative">
                            <img
                                src="/assets/sales/ajit yadav.jpeg" // Replace with correct path
                                alt="Ajit Yadav"
                                className="w-full h-full min-h-[400px] object-cover"
                            />

                            {/* Floating Name Box */}
                            {/* <div className="absolute bottom-8 left-8 right-8 bg-white p-6 shadow-lg">
                                <h3 className="font-bold text-2xl md:text-[28px] text-[#01386A] text-center mb-1">
                                    Ajit Yadav
                                </h3>
                                <p className="font-medium text-[15px] text-[#49577A] text-center">
                                    Founder & CEO, Mobikode
                                </p>
                            </div> */}
                        </div>

                        <div className="w-full md:w-full p-8 md:p-14 lg:p-16 flex flex-col justify-center border-l-4 border-l-[#01386A] md:border-l-0 md:border-b-4 md:border-b-[#01386A] relative">

                            <Quote
                                size={40}
                                className="text-[#01386A] fill-[#01386A] absolute top-8 left-8 opacity-20"
                            />

                            <div className="z-10" >
                                <p className="font-[500] font-graphik text-[14px] md:text-[16px] text-justify leading-relaxed text-[#01386A]">
                                    <span className="text-2xl leading-none text-[#01386A] font-graphik mr-1">"</span>
                                    At Mobikode, our journey began with a simple yet powerful belief: technology should not just support businesses, it should accelerate them.    When I founded Mobikode in 2017, the vision was clear: to build a technology partner that delivers not only solutions, but measurable impact.
                                    Today, as digital transformation continues to redefine industries, our focus remains stronger than ever.
                                    <span className="text-2xl leading-none text-[#01386A] font-serif ml-1">"</span>
                                </p>

                            </div>

                            <h3 className="text-[#01386A] text-[16px] py-[20px] font-sora md:text-[20px] font-[600] font-sora">
                                Let's build the future together.
                            </h3>

                            <p className="font-[500] lg:text-[16px] text-[14px] leading-relaxed font-graphik text-[#01386A]">
                                Warm regards, <br />
                                Ajit Yadav <br />
                                <span className="lg:text-[16px] text-[14px] font-[500] font-graphik text-[#01386A]">Founder & CEO</span>
                            </p>
                            {/* Link with Arrow */}
                            <Link
                                to="/founders-message"
                                className="group flex items-center gap-3 text-[#01386A] font-semibold text-[16px] hover:text-[#49577A] transition-colors w-fit mt-auto"
                            >
                                {/* <span>Read Full Message</span> */}
                                <div className="group-hover:translate-x-2 transition-all duration-300">
                                    <ArrowRight size={26} className="text-[#01386A]" />
                                </div>
                            </Link>

                        </div>
                    </div>
                </div>
            </section>


            <OurValues />

            <WhatSetsUsApart />
        </div>
    )
}

export default WhoWeAre
